const { map, capitalize } = require('lodash');

export const toTitleCase = str =>
  typeof str === 'string' ? map(str?.split(' '), capitalize).join(' ') : str;
